import React from 'react'

const FeedbackIndex = () => {
  return (
    <div>
      Feedback
    </div>
  )
}

export default FeedbackIndex
